
















































































import { Vue, Component } from 'vue-property-decorator'
import { mapState } from 'vuex'
import { localStore } from '@/_utils/localstore'
import FlashMessage from '@/components/common/FlashMessage.vue'

@Component({
  components: { FlashMessage },
  computed: {
    ...mapState('authentication', {
      flashMessages: 'messages'
    })
  }
})
export default class Login extends Vue {
  // data
  private username: string = ''
  private password: string = ''
  private submitted: boolean = false
  private isActive: boolean = false
  private flashMessages!: object
  // computed
  get loggingIn(): any {
    return this.$store.state.authentication.status.loggingIn
  }
  // methods
  private handleSubmit(): any {
    this.submitted = true
    const { username, password } = this
    const { dispatch } = this.$store
    if (username && password) {
      dispatch('authentication/login', { username, password })
    }
  }

  private handleChangeLang(lang: string): void {
    localStore.setItem('lang', lang)
    location.reload(true)
  }

  // Lifecycle hooks
  private created() {
    this.$store.dispatch('authentication/logout')
  }
}
